import { render, staticRenderFns } from "./TournamentTeamSetupForm.vue?vue&type=template&id=062f8b7a&scoped=true"
import script from "./TournamentTeamSetupForm.vue?vue&type=script&lang=js"
export * from "./TournamentTeamSetupForm.vue?vue&type=script&lang=js"
import style0 from "./TournamentTeamSetupForm.vue?vue&type=style&index=0&id=062f8b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f8b7a",
  null
  
)

export default component.exports